import React from 'react';
import { ProgressList } from 'react-design-components';
import { getNavigation } from '../Navigation';
import { ComponentsEnum } from '../../../types';

const useNavigation = (currentId?: ComponentsEnum) => {
  if (!currentId) return null;

  return <ProgressList items={getNavigation()} currentId={currentId} />;
};

export default useNavigation;
